import { render, staticRenderFns } from "./PaymentLoadingPage.vue?vue&type=template&id=0cf9a3df&scoped=true"
import script from "./PaymentLoadingPage.vue?vue&type=script&lang=js"
export * from "./PaymentLoadingPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentLoadingPage.vue?vue&type=style&index=0&id=0cf9a3df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9a3df",
  null
  
)

export default component.exports